import { blend } from '../tint';
import type { PrecipitationType } from '@/types/weather';

interface Props {
  skyColor: string;
  precipitation: PrecipitationType;
  isNight: boolean;
}

const SNOWY: PrecipitationType[] = ['snow', 'sleet'];

// Ground tracks scene brightness: green by default (blended toward sky),
// white when snow has settled, darker at night.
export function GroundLayer({ skyColor, precipitation, isNight }: Props) {
  const snowing = SNOWY.includes(precipitation);
  let groundColor: string;
  if (snowing) {
    groundColor = blend('#F4F8FF', skyColor, isNight ? 0.45 : 0.15);
  } else {
    const base = isNight ? '#1E3A1A' : '#4A7A3A';
    groundColor = blend(base, skyColor, 0.45);
  }
  return (
    <div className="layer" style={{ zIndex: 75, pointerEvents: 'none' }}>
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '4vh',
          background: groundColor,
          transition: 'background 4s ease-in-out',
        }}
      />
    </div>
  );
}
